<template>
  <div id="mLiveScorePage">
    <iframe id="my-iframe" :src="src"></iframe>
  </div>
</template>

<script>
  import i18n from '@/i18n';
  export default {
    name: 'mLiveScorePage',
    computed: {
      src() {
        const { locale } = i18n;
        const locale2 = ['vi'].includes(locale) ? 'en' : locale;
        const path = `score/${locale2}`;
        return path;
      },
    },
  };
</script>

<style lang="scss" scoped>
  #mLiveScorePage {
    flex: 1;

    iframe {
      height: 100%;
      width: 100%;
      border: none;
    }
  }
</style>
